
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  Button,
  Grid,
  TextField,
  TableContainer,
  Paper,
  TablePagination,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ListItem,
  Pagination,
  ListItemText,
  List,
  Alert,
  Stack,
  Box
} from '@mui/material';
import exportFromJSON from 'export-from-json';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import styles from './Depository.module.css';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import AppConfig from '../AppConfig';
import ApiClient from '../utilities/apiClient';
import { useAppData } from '../redux/appDataProvider';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import MyModal from "../components/session_expired"
import xlsexport from 'xlsexport'
import MyLodder from '../components/lodder';
import { margin } from '@mui/system';
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  // Empty dependency array to fetch data only once on component mount



  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const columns = [
  { id: 'SCRIP_NAME', label: 'SCRIPT' }, // srini - 17/12/24
  { id: 'ISIN', label: 'ISIN' },
  { id: 'FreeQTY', label: 'Free Balance' },
  { id: 'PLedgeQTY', label: 'Pledge' },
  { id: 'PLEDGE_QTY', label: 'Pledge Demat' },
  { id: 'LockinQty', label: 'Lockin' },
  { id: 'Pending remat', label: 'Pending remat' },
  { id: 'NET', label: 'Total' },
  { id: 'SCRIP_VALUE', label: 'Closing Rate' },
  { id: 'AMOUNT', label: 'Amount' },
  { id: 'AMOUNT1', label: 'EarnmarkQty ' },
];
const columnstx = [

  { id: 'BDATE', label: 'Date', width: '25px' },
  { id: 'SCRIP_NAME', label: 'SCRIP', width: '150px' },
  { id: 'ISIN', label: 'ISIN', width: '100px' },
  { id: 'TRANS_DESCRIPTION', label: 'Transaction Details', width: '300px' },
  { id: 'BUYSALE_FLG', label: 'Type', width: '75px' },
  { id: 'CR_QTY', label: 'Qty', width: '75px' },
  { id: 'FINAL_FEE', label: 'Fee', width: '75px' },

];
const Depository = (


  setDatePickerValue,
  handleBOIDChange,

  handleDownload,
) => {
  const [value, setValue] = React.useState(1);
  const [dpdata, setDpdata] = React.useState([]);
  const { userInfo, setUserInfo } = useAppData();

  const [fdate, SetFDate] = React.useState(dayjs(new Date()));
  const [tdate, SetTDate] = React.useState(dayjs(new Date()));
  const apiToken = useSelector(state => state.auth.apiToken);
  const [showmodal, setShowModal] = React.useState(false);
  const [showlodder, setShowLodder] = React.useState(false);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const screen800px = useMediaQuery("(max-width : 800px)")
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [mpage, setMPage] = useState(1);
  const [mdata, setMdata] = useState([])

  const handlePageChange = (event, newpage) => {
    setPage(newpage);
  }
  const handleMPageChange = (event, newpage) => {
    setMPage(newpage);
  }

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  }
  useEffect(() => {
    const newArr = dpdata && dpdata.slice((mpage - 1) * 5, (mpage) * 5)

    setMdata(newArr)
  }, [mpage, dpdata])

  const customScrollbarStyles = {
    width: "100%",
    marginTop: "10px",
    scrollbarWidth: "thin",
    scrollbarColor: 'rgba(170,170,170,0.4) transparent',
  };

  useEffect(() => {
    window.scrollTo(0, 0)
    let fdate = dayjs(tdate).subtract(90, 'day')
    SetFDate(dayjs(fdate))
  }, []);

  useEffect(() => {
    SetTDate(dayjs(new Date()))

    setTimeout(() => {
      if (value === 0) {
        dpHoldingData()
      }
      if (value === 1) {
        dpTrasnsactionData()
      }
    }, 10)

  }, [value])

  const ExportDistWise = (data) => {
    const fileName = "Depository"
    const exportType = exportFromJSON.types.csv
    exportFromJSON({ data, fileName, exportType })
  }

  const handleChange = (event, newValue) => {

    setDpdata([])
    setValue(newValue);
  };


  const handleSubmit = () => {
    if (value === 0) {
      dpHoldingData()
    }
    if (value === 1) {
      dpTrasnsactionData()
    }
  }
  function dpTrasnsactionData() {
      // let tdate=dayjs(new Date()).format('DD/MM/YYYY')
      //  let tdate1= dayjs(new Date()).format('YYYY-MM-DD')
      // let  fdate=dayjs(tdate1).subtract(90, 'day').format('DD/MM/YYYY')
       console.log("1",fdate)
       console.log("2",tdate)
    let fdata = []
    try {
      setShowLodder(true)
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.Depository.transactions,
        "POST",
        {
          "COMPANY_CODE": 'CDSL',
          "FROM_DATE": dayjs(fdate).format('DD/MM/YYYY'),
          "TO_DATE": dayjs(tdate).format('DD/MM/YYYY'),
          "ISIN": '',
          // "Client_code": userInfo.CLIENT_ID,
          "DatabaseName": "Depository",
          "TRADING_CODE":  userInfo.CLIENT_ID,
          "BOID": userInfo.CLIENT_DP_CODE,
          "TRANS_TYPE": "",
          "DEBIT_CREDIT": "",
          "DEBIT_CREDIT": "",
          "EXCLUDE_BOID": "",
          "EXCLUDE_DPID": "",
          "AMOUNT": "",
        })
        .then((response) => {
          setShowLodder(false)
          if (response === 401) {

            setShowModal(true)
          }

          if (response && response.Success == "True" && response.hasOwnProperty("Success Description")) {
            let responseData = response["Success Description"];
            console.info(`data ${responseData}`);

            let re = responseData.map(data => {
              return {
                ISIN: data.ISIN,

                SCRIP_NAME: data.SCRIP_NAME,
                BDATE: data.BDATE,
                TRANS_DESCRIPTION: data.TRANS_DESCRIPTION,
                BUYSALE_FLG: data.BUYSALE_FLG,
                CR_QTY: data.CR_QTY > 0 ? parseFloat(data.CR_QTY).toFixed(2) : parseFloat(data.DR_QTY).toFixed(2),
                FINAL_FEE: data.FINAL_FEE

              }

            })

            // sorting dp transations date - 19-07-24 - Dev Srini
            const parseDate = (dateString) => {
              const [day, month, year] = dateString.split('/').map(Number);
              return new Date(year, month - 1, day);
            };

            re.sort((a, b) => {
              const dateA = parseDate(a.BDATE);
              const dateB = parseDate(b.BDATE);

              return dateB - dateA; // Sorting from latest to oldest
            });

            setDpdata(re)

          }
          if (response && response.Success == "False" && response.hasOwnProperty("Error Description")) {
            setDpdata([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  }
  // if(value===0)
  function dpHoldingData() {
    try {
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
      setShowLodder(true)
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.Depository.dpholding,
        "POST",
        {
          "Client_code": userInfo.CLIENT_ID ? userInfo.CLIENT_ID : localStorage.getItem('userid'),
          "To_date": dayjs(tdate).format('DD/MM/YYYY'),
          BO_ID: userInfo?.CLIENT_DP_CODE
        })
        .then((response) => {
          console.info(response);
          setShowLodder(false)
          if (response === 401) {

            setShowModal(true)
          }
          if (response && response.Success == "True" && response.hasOwnProperty("Success Description")) {
            let responseData = response["Success Description"];

            // Filtering dp transactions date - 19-07-24 - Dev Srini

            const filterDpTransactions = responseData.map(item => {
              return {
                SCRIP_NAME: item.SCRIP_NAME,
                ISIN: item.ISIN,
                FreeQTY: item.FreeQTY,
                PLedgeQTY: item.PLedgeQTY,
                PLEDGE_QTY: item.PLEDGE_QTY,
                LockinQty: item.LockinQty,
                NET: item.NET,
                SCRIP_VALUE: item.SCRIP_VALUE,
                AMOUNT: item.AMOUNT,
                AMOUNT1: item.AMOUNT1
              }
            })
            setDpdata(filterDpTransactions)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  }
  // }

  return (
    <Container sx={{ background: isSmallScreen ? "#241E41" : "#241E41", minHeight: "100vh" }} >
      {isSmallScreen &&
        <Typography sx={{ fontSize: "30px", padding: "10px 0px 0px 15px" }}>
          Depository
        </Typography>
      }
      <Box sx={{ borderBottom: 1, borderColor: 'divider', margin: "0px 10px 0px 10px" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor='secondary'
          indicatorColor='primary'
          aria-label="Depository">
          {/* <Tab label="Dp Holding" {...a11yProps(0)} /> */}
          <Tab label="Dp Transactions" {...a11yProps(1)} />
          {/* Commneted margin pledge tab -02-08-24 - Dev Srini */}
          {/* <Tab label="Margin Pledge" {...a11yProps(2)} /> */}
        </Tabs>
      </Box>
      {
        isSmallScreen ? <>
          <Grid container rowSpacing={3} columnSpacing={1} item xs={12} justifyContent="Center">
            <Grid item xs={12} sx={{ margin: "20px 15px 0px 15px" }}>
              <TextField
                label="BO ID"
                size="small"
                placeholder="BO ID"
                value={userInfo.CLIENT_DP_CODE}
                InputLabelProps={{ shrink: true }}
                onChange={handleBOIDChange}
                fullWidth
              />
            </Grid>
            {value !== 1 &&
              <Grid item xs={6}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="Date"
                    size="small"

                    format="DD/MM/YYYY"
                    value={tdate}
                    onChange={(newValue) => SetTDate(newValue)}

                    sx={{ "& .MuiInputBase-root": { height: 40, display: "flex", alignItems: "center" }, backgroundColor: "#131E2E", marginLeft: "15px", width: "95%" }}

                    fullWidth
                  />
                </LocalizationProvider>
              </Grid>
            }

            {value === 1 &&
              <Grid item xs={6} >
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="From Date"
                    size="small"

                    format="DD/MM/YYYY"
                    value={fdate}
                    onChange={(newValue) => SetFDate(newValue)}

                    sx={{ "& .MuiInputBase-root": { height: 40, display: "flex", alignItems: "center" }, backgroundColor: "#131E2E", marginLeft: "15px", width: "95%" }}

                    fullWidth
                  />
                </LocalizationProvider>
              </Grid>
            }

            {value === 1 &&
              <Grid item xs={6}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="To Date"
                    size="small"

                    format="DD/MM/YYYY"
                    value={tdate}
                    onChange={(newValue) => SetTDate(newValue)}

                    sx={{ "& .MuiInputBase-root": { height: 40, display: "flex", alignItems: "center" }, backgroundColor: "#131E2E", marginRight: "15px", width: "93%" }}


                  />
                </LocalizationProvider>
              </Grid>
            }
            <Grid item xs={value === 0 ? 5 : 12} margin="0px 15px 0px 15px">
              {/* Changed to onTouch event - 23-07-24 - Dev Srini */}
              <Button
                variant="contained"
                size="large"
                className={styles.mainbutton}
                fullWidth
                onTouchStart={() => handleSubmit()}
                sx={{ height: "40px" }}
              >Submit</Button>
            </Grid>
            <Grid item xs={6} sx={{ marginLeft: "20px" }} >
              <Button
                variant="outlined"
                size="large"
                className={styles.outlinedButton}
                onTouchStart={() => ExportDistWise(dpdata)}
                fullWidth
              >Download CSV</Button>
            </Grid>

            {dpdata.length == 0 ? (

              <Alert severity="warning" style={{ background: 'transparent', marginTop: "20px" }}>No Transactions found !</Alert>

            ) : (<List sx={{ width: isSmallScreen ? "100%" : "92%", background: "#0B1420", margin: "20px 10px 0px 20px", borderRadius: "10px" }}>
              {dpdata.length > 0 && mdata.map((item, index) => {
                return (
                  <ListItem key={index} className={styles.listItem}
                    sx={{ display: "flex", flexDirection: "column", alignItems: "start", borderBottom: "2px solid #1B2636" }}
                  >
                    <ListItemText
                      sx={{ width: "100%" }}
                      primary={
                        <Box display="flex" >
                          <Grid width="40%">
                            <Typography className={styles.listPrimaryText}  >Script</Typography>
                            {/* srini - 17/12/24 */}
                          </Grid>
                          <Grid width={value == 0 && "10%" || value == 1 && "30%"}>
                            <Typography className={styles.listPrimaryText}>ISIN</Typography>
                          </Grid>
                          {value == 1 &&
                            <Grid width="30%">
                              <Typography className={styles.listPrimaryText} marginLeft="10px">Date</Typography>
                            </Grid>}
                        </Box>
                      }
                      secondary={
                        <Box display="flex">
                          <Grid width="40%">
                            <Typography marginRight="15px" className={styles.listSecondaryText}>{item.SCRIP_NAME}</Typography>
                          </Grid>
                          <Grid width={value == 0 && "10%" || value == 1 && "30%"}>
                            <Typography className={styles.listSecondaryText}>{item.ISIN}</Typography>
                          </Grid>
                          {value == 1 &&
                            <Grid width="30%" >
                              <Typography className={styles.listSecondaryText} marginLeft="10px">{item.BDATE}</Typography>
                            </Grid>}
                        </Box>
                      }
                    />
                    <ListItemText
                      sx={{ width: "100%" }}
                      primary={
                        <Box display="flex" >
                          <Grid width="40%">
                            {value == 0 && <Typography className={styles.listPrimaryText}>Free Balance</Typography>}
                            {value == 1 && <Typography className={styles.listPrimaryText}>Type</Typography>}
                          </Grid>
                          <Grid width="30%">
                            {value == 0 && <Typography className={styles.listPrimaryText}>Pledge</Typography>}
                            {value == 1 && <Typography className={styles.listPrimaryText}>QTY</Typography>}
                          </Grid>
                          <Grid width="30%">
                            {value == 0 && <Typography className={styles.listPrimaryText} marginLeft="10px">Pledge Demat</Typography>}
                            {value == 1 && <Typography className={styles.listPrimaryText} marginLeft="10px">Fee</Typography>}
                          </Grid>
                        </Box>
                      }
                      secondary={
                        <Box display="flex" >
                          <Grid width="40%">
                            {value == 0 && <Typography className={styles.listSecondaryText} >
                              {parseFloat(item.FreeQTY).toString()}
                            </Typography>}
                            {value == 1 && (
                              item.BUYSALE_FLG === "B" ? <div className={styles.buydiv} >
                                <Typography className={styles.buy} >
                                  BUY
                                </Typography>
                              </div> :
                                <div className={styles.selldiv} >
                                  <Typography className={styles.sell} >
                                    SELL
                                  </Typography>
                                </div>
                            )}

                          </Grid>
                          <Grid width="30%">
                            <Typography className={styles.listSecondaryText} >
                              {value === 0 && parseFloat(item.PLedgeQTY).toString()}
                            </Typography>
                            {value == 1 && (
                              item.BUYSALE_FLG === "B" ?
                                <Typography className={styles.buy} sx={{ fontSize: "14px !important" }} >
                                  {parseInt(item.CR_QTY)}
                                </Typography>
                                :
                                <Typography className={styles.sell} sx={{ fontSize: "14px !important" }} >
                                  {item.CR_QTY}
                                </Typography>

                            )}
                          </Grid>
                          <Grid width="30%">
                            <Typography className={styles.listSecondaryText} marginLeft="10px" >
                              {value === 0 && parseFloat(item.PLEDGE_QTY).toString()}
                              {value === 1 && parseFloat(item.FINAL_FEE).toFixed(2)}
                            </Typography>
                          </Grid>
                        </Box>
                      }

                    />
                    {value == 0 && <ListItemText
                      sx={{ width: "100%" }}
                      primary={
                        <Box display="flex" >
                          <Grid width="40%">
                            <Typography className={styles.listPrimaryText}>Lockin</Typography>
                          </Grid>
                          <Grid width="30%">
                            <Typography className={styles.listPrimaryText}>Pending Remat</Typography>
                          </Grid>
                          <Grid width="30%">
                            <Typography className={styles.listPrimaryText} marginLeft="10px">Total</Typography>
                          </Grid>
                        </Box>
                      }
                      secondary={
                        <Box sx={{ display: "flex" }}>
                          <Grid width="40%">
                            <Typography className={styles.listSecondaryText} >{parseFloat(item.LockinQty).toString()}</Typography>
                          </Grid>
                          <Grid width="30%">
                            <Typography className={styles.listSecondaryText} ></Typography>
                          </Grid>
                          <Grid width="30%">
                            <Typography className={styles.listSecondaryText} marginLeft="10px" >{parseFloat(item.NET).toString()}</Typography>
                          </Grid>
                        </Box>
                      }

                    />}
                    {value == 0 && <ListItemText
                      sx={{ width: "100%" }}
                      primary={
                        <Box display="flex" >
                          <Grid width="40%">
                            <Typography className={styles.listPrimaryText}>Closing Rate</Typography>
                          </Grid>
                          <Grid width="30%">
                            <Typography className={styles.listPrimaryText}>Amount</Typography>
                          </Grid>
                          <Grid width="30%">
                            <Typography className={styles.listPrimaryText} marginLeft="10px">EarnmarkQty</Typography>
                          </Grid>
                        </Box>
                      }
                      secondary={
                        <Box sx={{ display: "flex", width: "100%" }}>
                          <Grid width="40%">
                            <Typography className={styles.listSecondaryText} >{parseFloat(item.SCRIP_VALUE).toFixed(2)}</Typography>
                          </Grid>
                          <Grid width="30%">
                            <Typography className={styles.listSecondaryText} >{item.AMOUNT}</Typography>
                          </Grid>
                          <Grid width="30%">
                            <Typography className={styles.listSecondaryText} marginLeft="10px" >{parseFloat(item.AMOUNT1).toString()}</Typography>
                          </Grid>
                        </Box>
                      }

                    />}
                  </ListItem>
                )
              })}
              <Grid sx={{ display: "flex", justifyContent: "center", padding: "10px 0px 10px 0px" }}>
                <Pagination showFirstButton showLastButton count={Math.ceil(dpdata.length / 5)} size="small" page={mpage}
                  onChange={handleMPageChange} />
              </Grid>
            </List>)}
          </Grid>
        </> : <>
          <Grid container rowSpacing={1} columnSpacing={1} item xs={12} sx={{ marginTop: "10px" }}  >
            <Grid item xs={screen800px ? value === 0 ? 5 : 12 : 4} >
              <TextField
                label="BO ID"
                size="small"
                placeholder="BO ID"
                value={userInfo.CLIENT_DP_CODE}
                InputLabelProps={{ shrink: true }}
                sx={{
                  backgroundColor: "#131E2E",
                  ".MuiOutlinedInput-notchedOutline": { border: "none" },
                  width: screen800px && value === 1 ? "66%" : "100%", marginBottom: "10px"
                }}
                onChange={handleBOIDChange}
              />
            </Grid>
            {

              value !== 1 &&
              <Grid item xs={screen800px ? 4 : 3}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="To Date"
                    size="small"
                    format="DD/MM/YYYY"
                    value={tdate}
                    onChange={(newValue) => SetTDate(newValue)}

                    sx={{ "& .MuiInputBase-root": { height: 40, display: "flex", alignItems: "center" }, backgroundColor: "#131E2E", ".MuiOutlinedInput-notchedOutline": { border: "none" } }}
                    fullWidth
                  />
                </LocalizationProvider>
              </Grid>
            }
            {

              value === 1 &&

              <Grid item xs={screen800px ? 4 : 2.8}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="From Date"
                    size="small"
                    format="DD/MM/YYYY"
                    value={fdate}
                    onChange={(newValue) => SetFDate(newValue)}

                    sx={{ "& .MuiInputBase-root": { height: 40, display: "flex", alignItems: "center" }, backgroundColor: "#131E2E", ".MuiOutlinedInput-notchedOutline": { border: "none" } }}
                    fullWidth
                  />
                </LocalizationProvider>

              </Grid>


            }
            {

              value === 1 &&

              <Grid item xs={screen800px ? 4 : 2.8}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="TO Date"
                    size="small"
                    format="DD/MM/YYYY"
                    value={tdate}
                    onChange={(newValue) => SetTDate(newValue)}

                    sx={{ "& .MuiInputBase-root": { height: 40, display: "flex", alignItems: "center" }, backgroundColor: "#131E2E", ".MuiOutlinedInput-notchedOutline": { border: "none" } }}
                    fullWidth
                  />
                </LocalizationProvider>

              </Grid>


            }
            <Grid item xs={screen800px ? 3 : 2} >
              <Button
                variant="contained"
                size="large"
                className={styles.mainbutton}
                sx={{ fontWeight: "bold", width: value === 0 ? "90%" : "100%" }}
                onClick={() => handleSubmit()}
              >Submit</Button>
            </Grid>
            <Grid item sx={{ display: "flex", justifyContent: "start", gap: "5px" }}>
              <Button
                variant="outlined"
                size="large"
                className={styles.outlinedButton}
                onClick={() => ExportDistWise(dpdata)}
              >Download</Button>
            </Grid>
            {value === 1 &&
              // <div>
              <>
                <TableContainer component={Paper} className={styles.tableContainer} sx={customScrollbarStyles}>

                  <Table>



                    <TableHead>
                      <TableRow  >
                        {dpdata.length !== 0 && columnstx.map((column) => (
                          <TableCell className={styles.table_h} key={column.id} width={column.width} >{column.label} </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {dpdata.length === 0 &&

                        <TableRow style={{ display: 'flex', justifyContent: 'center' }}>


                          <Alert severity="warning" style={{ background: 'transparent' }}>No Transactions found !</Alert>


                        </TableRow>

                      }

                      {dpdata.length > 0 && dpdata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                        <TableRow key={index} >
                          {columnstx.map((column) => (
                            <TableCell
                              className={styles.table_data}
                              width={column.width}
                              key={column.id}>
                              {
                                column.id === "BUYSALE_FLG" ?
                                  (
                                    row[column.id] === "B" ?
                                      <div className={styles.buydiv}>
                                        <Typography className={styles.buy} >BUY</Typography>
                                      </div>
                                      : <div className={styles.selldiv}>
                                        <Typography className={styles.sell} >SELL</Typography>
                                      </div>
                                  )
                                  :
                                  column.id === "CR_QTY" ?
                                    (
                                      row[column.id] > 0 ?
                                        // amended qty in single digit - 19-07-24 - Dev Srini 
                                        <div >
                                          <Typography className={styles.buy} > {parseFloat(row[column.id]).toString()}</Typography>
                                        </div>
                                        : <div >
                                          <Typography className={styles.sell} > {parseFloat(row[column.id]).toString()}</Typography>
                                        </div>
                                    ) :
                                    <Typography className={styles.table_data}>
                                      {/* amended fees decimals values  - 19-07-24 - Dev Srini  */}
                                      {column.id === 'FINAL_FEE' && typeof row[column.id] === 'string' ? parseFloat(row[column.id]).toFixed(2) : row[column.id]}
                                    </Typography>}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                {dpdata.length > 0 && <TablePagination
                  sx={{ background: "#0B1420", width: "100%" }}
                  rowsPerPageOptions={[10, 20, 50]}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  count={dpdata.length}
                  component="div"
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleRowsPerPageChange}
                />}
              </>
            }
            {value === 0 &&
              <>
                <TableContainer component={Paper} className={styles.tableContainer} sx={customScrollbarStyles}>

                  <Table>



                    <TableHead>
                      <TableRow>
                        {dpdata.length !== 0 && columns.map((column) => (
                          <TableCell className={styles.table_h} key={column.id}>{column.label}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {dpdata.length === 0 &&

                        <TableRow style={{ display: 'flex', justifyContent: 'center' }}>


                          <Alert severity="warning" style={{ background: 'transparent' }}>No Transactions found !</Alert>


                        </TableRow>

                      }
                      {dpdata.length > 0 && dpdata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                        <TableRow key={index}>
                          {columns.map((column) => (
                            // below mentioned field values amended - 19-07-24 - Dev Srini 
                            <TableCell className={styles.table_data} key={column.id}>
                              {typeof row[column.id] === 'string' && ['NET', 'FreeQTY', 'PLedgeQTY', 'PLEDGE_QTY', 'LockinQty', 'AMOUNT1'].includes(column.id)
                                ? parseFloat(row[column.id]).toString()
                                : row[column.id]}
                            </TableCell>

                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                {dpdata.length > 0 && <TablePagination
                  sx={{ background: "#0B1420", width: "100%" }}
                  rowsPerPageOptions={[10, 20, 50]}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  count={dpdata.length}
                  component="div"
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleRowsPerPageChange}

                />}
              </>
            }


          </Grid>
        </>
      }
      <MyModal canShow={showmodal} />
      <MyLodder canShow={showlodder} />
    </Container>
  );

};

export default Depository;
